<mat-form-field appearance="fill" class="carrier-select">
  <mat-label>
    <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.carrier"></sc-dictionary-label>
  </mat-label>
  @if (!disableAutoComplete) {
    <input matInput name="carrier" [formControl]="formControl" matInput
      [matAutocomplete]="autoCarriers" [required]="required">
  }
  @if (disableAutoComplete) {
    <input matInput name="carrier" [formControl]="formControl" matInput
      [required]="required">
  }
  <mat-autocomplete autoActiveFirstOption #autoCarriers="matAutocomplete">
    <ng-container>
      @for (carrier of filteredCarriers; track carrier) {
        <mat-option [value]="carrier">
          <span>{{carrier}}</span>
        </mat-option>
      }
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
